import { defineComponent as c, useCssModule as m, computed as l, createElementBlock as v, openBlock as C, normalizeClass as b, unref as o, createElementVNode as h, mergeProps as B, renderSlot as $ } from "vue";
import y from "../../utils/mapClasses.mjs";
import z from "../../props/size.mjs";
import { buildBooleanClass as W } from "../../utils/buildClass.mjs";
const s = "cdr-table", P = /* @__PURE__ */ c({
  name: "CdrTable",
  __name: "CdrTable",
  props: {
    /** Sets row colors to alternate between darker and lighter backgrounds.
     * Striping will not apply when `border` is true
     */
    striped: {
      type: Boolean,
      default: !1
    },
    /** Adds borders between rows. Will disable `striped` if both are true */
    border: {
      type: Boolean,
      default: !0
    },
    /** Sets the width to 100%. Also accepts space separated strings for breakpoints that it should be full width: { '@xs' | '@sm' | '@md' | '@lg' } */
    fullWidth: {
      type: [Boolean, String],
      default: !0
    },
    /** Makes the table scroll horizontally when it would overflow its container */
    responsive: {
      type: Boolean,
      default: !0
    },
    /** Adds a darker background on row hover */
    hover: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets the table size (cell padding); values can target responsive breakpoints. Example `small@lg`.
     * @demoSelectMultiple false
     * @values small, medium, large
    */
    size: z
  },
  setup(a) {
    const e = a, t = m(), n = l(() => e.size ? `${s}--${e.size}` : ""), d = l(() => e.striped ? `${s}--striped` : ""), p = l(() => e.hover ? `${s}--hover` : ""), u = l(() => e.border && !e.striped ? `${s}--border` : ""), i = l(() => e.fullWidth ? W(s, e.fullWidth, "full-width") : ""), f = l(() => e.responsive ? `${s}--responsive` : "");
    return (r, _) => (C(), v("div", {
      class: b(o(t)[f.value])
    }, [h("table", B(r.$attrs, {
      class: o(y)(o(t), s, n.value, d.value, p.value, u.value, i.value)
    }), [$(r.$slots, "default")], 16)], 2));
  }
});
export {
  P as default
};
